import React from "react";
import {
  Paper,
  Tabs,
  Tab,
  Box,
  Typography,
  Badge,
} from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PaymentIcon from "@mui/icons-material/Payment";
import CancelIcon from "@mui/icons-material/Cancel";

const TabsSection = ({ activeTab, onTabChange, stats, loading, tabLoading }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 2,
        overflow: "hidden",
        mb: 3,
        border: "1px solid #e5e7eb",
      }}
    >
      <Tabs
        value={activeTab}
        onChange={onTabChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          bgcolor: "background.paper",
          "& .MuiTab-root": {
            minHeight: 64,
            minWidth: 140,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.95rem",
            transition: "all 0.3s",
            px: 3,
            color: "#64748b",
            "&:hover": {
              bgcolor: "action.hover",
            },
            "&.Mui-selected": {
              color: "#667eea",
            },
            "&.Mui-disabled": {
              opacity: 0.6,
            },
          },
          "& .MuiTabs-indicator": {
            height: 3,
            borderRadius: "3px 3px 0 0",
            backgroundColor: "#667eea",
          },
        }}
      >
        <Tab
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, py: 1 }}>
              <AssignmentIcon fontSize="small" />
              <Box>
                <Typography variant="body2" fontWeight={600}>
                  All
                </Typography>
                <Badge
                  badgeContent={stats.total}
                  color="primary"
                  sx={{
                    "& .MuiBadge-badge": {
                      position: "static",
                      transform: "none",
                      mt: 0.5,
                    },
                  }}
                />
              </Box>
            </Box>
          }
          disabled={loading || tabLoading}
        />
        <Tab
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, py: 1 }}>
              <HourglassEmptyIcon fontSize="small" />
              <Box>
                <Typography variant="body2" fontWeight={600}>
                  Pending
                </Typography>
                <Badge
                  badgeContent={stats.pending}
                  color="warning"
                  sx={{
                    "& .MuiBadge-badge": {
                      position: "static",
                      transform: "none",
                      mt: 0.5,
                    },
                  }}
                />
              </Box>
            </Box>
          }
          disabled={loading || tabLoading}
        />
        <Tab
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, py: 1 }}>
              <CheckCircleIcon fontSize="small" />
              <Box>
                <Typography variant="body2" fontWeight={600}>
                  Accepted
                </Typography>
                <Badge
                  badgeContent={stats.accepted}
                  color="info"
                  sx={{
                    "& .MuiBadge-badge": {
                      position: "static",
                      transform: "none",
                      mt: 0.5,
                    },
                  }}
                />
              </Box>
            </Box>
          }
          disabled={loading || tabLoading}
        />
        <Tab
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, py: 1 }}>
              <PaymentIcon fontSize="small" />
              <Box>
                <Typography variant="body2" fontWeight={600}>
                  Verifying
                </Typography>
                <Badge
                  badgeContent={stats.verifying}
                  color="success"
                  sx={{
                    "& .MuiBadge-badge": {
                      position: "static",
                      transform: "none",
                      mt: 0.5,
                    },
                  }}
                />
              </Box>
            </Box>
          }
          disabled={loading || tabLoading}
        />
        <Tab
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, py: 1 }}>
              <CancelIcon fontSize="small" />
              <Box>
                <Typography variant="body2" fontWeight={600}>
                  Rejected
                </Typography>
                <Badge
                  badgeContent={stats.rejected}
                  color="error"
                  sx={{
                    "& .MuiBadge-badge": {
                      position: "static",
                      transform: "none",
                      mt: 0.5,
                    },
                  }}
                />
              </Box>
            </Box>
          }
          disabled={loading || tabLoading}
        />
      </Tabs>
    </Paper>
  );
};

export default TabsSection;